import React, { useState } from "react";
import arrowDropDown from "../assets/arrow_drop_down.svg";

interface Option {
  label: string;
  value: string;
}

interface DropdownProps {
  options: Option[];
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  className?: string;
  width?: string | number;
  dropdownWidth?: string | number;
}

const Dropdown: React.FC<DropdownProps> = ({
  options,
  value,
  placeholder = "Select an option",
  onChange,
  className = "",
  width = "100%",
  dropdownWidth,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (selectedValue: string) => {
    onChange(selectedValue);
    setIsOpen(false);
  };

  const selectedOption = options.find((option) => option.value === value);
  const buttonWidth = typeof width === "number" ? `${width}vh` : width;
  const listWidth = dropdownWidth
    ? typeof dropdownWidth === "number"
      ? `${dropdownWidth}vh`
      : dropdownWidth
    : buttonWidth;

  return (
    <div className={`relative ${className}`} style={{ width: buttonWidth }}>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="w-full h-11 px-6 text-left bg-white text-[#4C4C4C] text-sm font-medium flex items-center justify-between rounded-[8px] border border-[#DBDBDB] hover:bg-gray-50 focus:outline-none"
      >
        <span className="font-medium leading-5 font-ubuntu text-sm truncate">
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <img
          className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          src={arrowDropDown}
          alt="toggle"
        />
      </button>

      {isOpen && (
        <div
          className="absolute mt-1 bg-white border-2 rounded shadow-lg z-20"
          style={{ width: listWidth }}
        >
          <ul className="p-2 max-h-60 overflow-auto flex flex-col items-start no-scrollbar">
            <li
              onClick={() => handleSelect("")}
              className="w-full px-6 py-2 text-sm leading-5 font-ubuntu rounded hover:bg-[#DBDBDB] cursor-pointer"
            >
              {placeholder}
            </li>
            {options.map((option) => (
              <li
                key={option.value}
                onClick={() => handleSelect(option.value)}
                className="w-full px-6 py-2 text-sm font-ubuntu leading-5 rounded truncate hover:bg-[#DBDBDB] cursor-pointer"
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
